import React from 'react'
import { TabsHeader, Tab } from '@material-tailwind/react/components/Tabs'
import { Link } from 'gatsby'

export const TabsHeaderCommon = ({
  tabsTitle,
  setActiveTab,
  color,
}: {
  tabsTitle: { label: string; key: string; pill?: number }[]
  setActiveTab: (tab: string) => void
  color?: string
}) => (
  <TabsHeader
    className="z-10 h-16 gap-8 p-0 mx-auto bg-transparent border-b rounded-none border-blue-gray-50 max-w-fit lg:ml-4"
    indicatorProps={{
      className:
        'bg-transparent border-b-2 border-primary shadow-none rounded-none',
      style: {
        borderColor: color || undefined,
      },
    }}
  >
    {tabsTitle.map((tabHeader) => (
      <Tab
        key={`tab-${tabHeader.key}`}
        value={tabHeader.key}
        className={
          tabHeader.key
            ? ' rounded-lg font-semibold lg:text-lg text-sm lg:max-w-fit max-w-min '
            : 'font-semibold rounded-lg lg:text-lg text-sm lg:max-w-fit max-w-min'
        }
        onClick={() => setActiveTab(tabHeader.key)}
      >
        <Link to={`?tab=${tabHeader.key}`}>
          <div className="flex items-center justify-center gap-2 flex-nowrap">
            {tabHeader.label}
            {tabHeader.pill && (
              <div
                className="flex items-center justify-center text-sm text-white rounded-full bg-primary h-7 w-7"
                style={{
                  backgroundColor: color || undefined,
                }}
              >
                {tabHeader.pill}
              </div>
            )}
          </div>
        </Link>
      </Tab>
    ))}
  </TabsHeader>
)
